import React from 'react'
import { Form } from 'react-bootstrap'

const OrderStatusFilter = ({ filters, handleChange }) => {
  return (
    <div className='col-3 add'>
      <Form.Select
        value={filters.status || ""}
        onChange={(e) => handleChange("status", e.target.value)}
      >
        <option value="">حالة الطلب</option>
        <option value="pending">قيد الانتظار</option>
        <option value="delivered">تم التوصيل</option>
        <option value="cancelled">تم الإلغاء</option>
        <option value="processing">قيد المعالجة</option>
        <option value="confirmed">تم التأكيد</option>
        <option value="on_way">في الطريق</option>
      </Form.Select>
    </div>
  )
}

export default OrderStatusFilter
